import { cn } from "../lib/cn";

export interface StepperProps {
  steps: string[];
  currentStep: number;
  className?: string;
}

export function Stepper({ steps, currentStep, className }: StepperProps) {
  return (
    <div className={cn("flex items-center gap-0", className)}>
      {steps.map((step, i) => {
        const isCompleted = i < currentStep;
        const isCurrent = i === currentStep;

        return (
          <div key={i} className="flex items-center">
            {i > 0 && (
              <div
                className={cn(
                  "h-px w-8 transition-colors",
                  isCompleted ? "bg-gold" : "bg-[rgba(255,255,255,0.08)]",
                )}
              />
            )}
            <div className="flex flex-col items-center gap-1.5">
              <div
                className={cn(
                  "flex h-6 w-6 items-center justify-center rounded-full font-mono text-[9px] transition-colors",
                  isCompleted && "bg-gold text-black",
                  isCurrent && "border-gold text-gold border-2",
                  !isCompleted &&
                    !isCurrent &&
                    "text-text-muted border border-[rgba(255,255,255,0.15)]",
                )}
              >
                {isCompleted ? "\u2713" : i + 1}
              </div>
              <span
                className={cn(
                  "whitespace-nowrap font-mono text-[8px] uppercase tracking-[0.10em]",
                  isCurrent ? "text-gold" : "text-text-muted",
                )}
              >
                {step}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
